/* eslint-disable */
// All ESLint errors will be ignored in this file

export default function cn(...classes) {
  return classes.filter(Boolean).join(" ")
}
